module.exports = [
  {
    path: '/birds',
    component: true,
    redirect: '/birds/list',
    name: '鹦鹉管理',
    children: [
      {
        path: 'list',
        name: '列表',
        component: () => import('@/views/birds/list'),
      },
      {
        path: 'form',
        name: '表单',
        component: () => import('@/views/birds/form'),
      },
    ]
  },
]


// WEBPACK FOOTER //
// ./src/router/birds.js